import { useStateMachine } from "little-state-machine";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { updateSelectedHwrcSite } from "actions/updateSelectedHwrcSite";
import IHwrcSite from "interfaces/IHwrcSite";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";

const EditTemplate = (props: any): any => {
  const navigate = useNavigate();
  const { actions } = useStateMachine({ updateSelectedHwrcSite });
  const {
    id, name, regionId, code, latitude, longitude, active, inUse
  } = props;

  const onEditClickHandler = () => {
    const hwrcSite: IHwrcSite = {
      id, name, regionId, code, latitude, longitude, active, inUse
    };
    actions.updateSelectedHwrcSite(hwrcSite);
    navigate(RoutePathsEnum.SettingsHwrcSitesUpdate);
  };

  return (
    <div className="d-flex justify-content-center">
      <Button
        variant="primary"
        data-testid="edit-hwrcsite"
        aria-label={`Edit ${name} hwrc site`}
        onClick={onEditClickHandler}
      >
        Edit
      </Button>
    </div>
  );
};
export default EditTemplate;
